import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PopupLayout from '@appbase/templates/PopupLayout/PopupLayout.vue'
import { ModalLayout } from '@appbase/templates'

@Component({
  components: { PopupLayout,ModalLayout },
})
export default class PopupViewMaster extends Vue {

  title:string= ''
  created(){
    if(this.$route.query){
      const popupItemQuery = this.$route.query.popupItem as string
      const popupSubjectQuery = this.$route.query.popupSubject as string

      if (popupItemQuery) {
        try {
          const popItem = JSON.parse(popupItemQuery)
          this.title = popItem.subject || popupSubjectQuery || ''
        } catch (e) {
          this.title = popupSubjectQuery || ''
        }
      } else {
        this.title = popupSubjectQuery || ''
      }
    }
  }
}
